<template>
    <div class="b-sidebar-body" :hidden="$props.toggleCollapsed">
        <div class="sidebar">
            <div class="header-sidebar">
                <div class="sidebar-title">
                    Questions bank
                </div>
                <!--<div v-if="isShowHide_Left_Menu()">-->
                <div>
                    <a-menu mode="inline" :defaultSelectedKeys="openKeys" theme="dark">
                        <a-menu-item @click="handleClickMenu(sidebarItems[0].to)"
                                     :hidden="isHidden(sidebarItems[0].role)" :key="sidebarItems[0].to">
                            <b-icon :icon="sidebarItems[0].icon" class="mr-2"></b-icon>
                            {{ $t(sidebarItems[0].label) }}
                        </a-menu-item>
                        <a-sub-menu :key="sidebarItems[1].label"
                                    :hidden="isHidden(sidebarItems[1].role)">
                            <span slot="title">
                                <b-icon :icon="sidebarItems[1].icon" class="mr-2"></b-icon>
                                <span>
                                    {{
                                        $t(sidebarItems[1].label)
                                    }}
                                </span>
                            </span>
                            <a-menu-item v-for="child in sidebarItems[1].children" :key="child.to" @click="handleClickMenu(child.to)"
                                         :hidden="isHidden(child.role)">
                                {{ $t(child.label) }}
                            </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item @click="handleClickMenu(sidebarItems[2].to)"
                                     :hidden="isHidden(sidebarItems[2].role)" :key="sidebarItems[2].to">
                            <b-icon :icon="sidebarItems[2].icon" class="mr-2"></b-icon>
                            {{ $t(sidebarItems[2].label) }}
                        </a-menu-item>
                        <a-sub-menu :key="sidebarItems[3].label"
                                    :hidden="isHidden(sidebarItems[3].role)">
                            <span slot="title">
                                <b-icon :icon="sidebarItems[3].icon" class="mr-2"></b-icon>
                                <span>
                                    {{
                                        $t(sidebarItems[3].label)
                                    }}
                                </span>
                            </span>
                            <a-menu-item v-for="child in sidebarItems[3].children" :key="child.to" @click="handleClickMenu(child.to)"
                                         :hidden="isHidden(child.role)">
                                {{ $t(child.label) }}
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu :key="sidebarItems[4].label"
                                    :hidden="isHidden(sidebarItems[4].role)">
                            <span slot="title">
                                <b-icon :icon="sidebarItems[4].icon" class="mr-2"></b-icon>
                                <span>
                                    {{
                                        $t(sidebarItems[4].label)
                                    }}
                                </span>
                            </span>
                            <a-menu-item v-for="child in sidebarItems[4].children" :key="child.to" @click="handleClickMenu(child.to)"
                                         :hidden="isHidden(child.role)">
                                {{ $t(child.label) }}
                            </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item v-for="child in sidebarItems[5].children" :key="child.to" @click="handleClickMenu(child.to)"
                                     :hidden="isHidden(child.role)">
                            <b-icon :icon="child.icon" class="mr-2"></b-icon>
                            {{ $t(child.label) }}
                        </a-menu-item>
                        <a-menu-item @click="handleClickMenu(sidebarItems[6].to)"
                                     :hidden="isHidden(sidebarItems[6].role)" :key="sidebarItems[6].to">
                            <b-icon :icon="sidebarItems[6].icon" class="mr-2"></b-icon>
                            {{ $t(sidebarItems[6].label) }}
                        </a-menu-item>
                        <a-menu-item @click="handleClickMenu(sidebarItems[7].to)"
                                     :hidden="isHidden(sidebarItems[7].role)" :key="sidebarItems[7].to">
                            <b-icon :icon="sidebarItems[7].icon" class="mr-2"></b-icon>
                            {{ $t(sidebarItems[7].label) }}
                        </a-menu-item>
                        <a-menu-item @click="handleClickMenu(sidebarItems[8].to)"
                                     :hidden="isHidden(sidebarItems[8].role)" :key="sidebarItems[8].to">
                            <b-icon :icon="sidebarItems[8].icon" class="mr-2"></b-icon>
                            {{ $t(sidebarItems[8].label) }}
                        </a-menu-item>
    <!--                    <a-sub-menu v-for="item in sidebarItems" :key="item.label" v-if="item.children"-->
    <!--                                :hidden="isHidden(item.role)">-->
    <!--                        <span slot="title">-->
    <!--                            <b-icon :icon="item.icon" class="mr-2"></b-icon>-->
    <!--                            <span>-->
    <!--                                {{-->
    <!--                                    $t(item.label)-->
    <!--                                }}-->
    <!--                            </span>-->
    <!--                        </span>-->
    <!--                        <a-menu-item v-for="child in item.children" :key="child.to" @click="handleClickMenu(child.to)"-->
    <!--                                     :hidden="isHidden(child.role)">-->
    <!--                            {{ $t(child.label) }}-->
    <!--                        </a-menu-item>-->
    <!--                    </a-sub-menu>-->
    <!--                    <a-menu-item v-for="item in sidebarItems" :key="item.to" @click="handleClickMenu(item.to)"-->
    <!--                                 :hidden="isHidden(item.role)" v-if="!item.children && item.name !==`TeacherList`">-->
    <!--                        <b-icon :icon="item.icon" class="mr-2"></b-icon>-->
    <!--                        {{ $t(item.label) }}-->
    <!--                    </a-menu-item>-->
                    </a-menu>
                </div>
            </div>
            <div class="footer-sidebar">
                <img class="logo-sidebar" src="../../assets/images/Exam/exam_new.png" alt=""/>
            </div>
        </div>
      </div>

</template>

<script>
import { mapGetters } from "vuex";
import { SIDEBAR_ITEMS } from "../../assets/constant";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      openKeys: [window.location.pathname],
      roleUser: null
    };
  },
  props: ["toggleCollapsed"],
  computed: {
    ...mapGetters({
      // listTags: "tag/tagResponse",
      // listProblem: "problem/getNewProblemResponse"
      locales: "lang/locales",
      locale: "lang/locale",
      isLogin: "auth/isLogin",
      permissions: "auth/permissions",
      user: "auth/user"
    }),
    sidebarItems() {
      // return SIDEBAR_ITEMS.filter(item => {
      //   return (
      //     this.permissions.includes(item.permission) && item.isShow == "true"
      //     // item.isShow == "true"
      //   );
      // });
        if (this.user?.business_id) {
            SIDEBAR_ITEMS[5].children = SIDEBAR_ITEMS[5].children.filter(item => item.name !== "ExamStudent");
        }
      return SIDEBAR_ITEMS;
    }
  },
  created() {
       this.roleUser = this.user.roles_teacher;
  },
  methods: {
    handleClickMenu(path) {
      window.location.pathname = path;
    },
    isHidden(role) {
      if (role) {
        for (let i = 0; i < role.length; i++) {
          if (this.roleUser === role[i]) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
    /*isShowHide_Left_Menu(){
        let flag = true;
        if(Cookies.get("redirect_from_mk_b2b")){
            flag = false;
        }
        return flag;
    }*/
  }
};
</script>

<style>
.sidebar-title {
  font-weight: bold;
  text-align: center;
  font-size: 32px;
}

.function-container {
  text-align: left;
  width: 100%;
}

.function-detail {
  transition: 0.5s;
  padding: 20px 20px;
  color: #fff;
  text-decoration: none !important;
}

.function-detail:hover {
  background-color: white;
  color: black;
  cursor: pointer;
  transition: 0.5s;
}

.b-sidebar-body {
  background-color: #6674bb;
  left: 0;
  height: 100vh;
  z-index: 100;
  width: 197px;
  color: white;
  padding: 22px 0px;
	position: sticky;
	top: 0;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 5px 10px 10px 10px;
  margin-bottom: -1px;
  background-color: #fff;
}

#topic-module {
  padding-top: 20px;
}

.btn.btn-default,
.btn.btn-default:active,
.btn.btn-default:active:focus,
.btn.btn-default:focus {
  border: 1px solid #ddd;
}

.btn-group-xs > .btn,
.btn-xs {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

.logo-sidebar {
  bottom: 0;
  width: 100%;
  border-radius: 100px;
  padding: 20px 20px;
}

.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  height: 100%;
  position: sticky;
  top: 0;
}

.header-sidebar {
  overflow: scroll;
  max-height: 80%;
}

.header-sidebar::-webkit-scrollbar {
  display: none !important;
}

.ant-menu-inline,
.ant-menu-sub.ant-menu-inline {
  background-color: #6674bb !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  width: 98% !important;
}

.ant-menu-submenu-arrow {
  color: white !important;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  box-shadow: none !important;
}

.ant-menu-dark .ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-active,
.ant-menu-dark .ant-menu-submenu-active,
.ant-menu-dark .ant-menu-submenu-selected,
.ant-menu.ant-menu-dark .ant-menu-item-selected {
  background: #8590c9 !important;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.05) !important;
  border-radius: 8px !important;
}

.ant-menu-inline,
.ant-menu-submenu {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.ant-menu-dark.ant-menu-inline .ant-menu-item {
  color: white !important;
  width: 195px !important;
}

.ant-menu-dark.ant-menu-inline {
  width: 197px !important;
}
</style>
